import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreHorizontal } from "lucide-react";

interface AdminUserActionMenuProps {
  employeeUuid: string;
  isActive: boolean;
  onEdit: (uuid: string) => void;
  onImpersonate: (employeeUuid: string) => void;
  onViewSyncLogs: () => void;
  onSyncUser: () => void;
  onDeactivateUser: () => void;
}

const AdminUserActionMenu: React.FC<AdminUserActionMenuProps> = ({
  employeeUuid,
  isActive,
  onEdit,
  onImpersonate,
  onViewSyncLogs,
  onSyncUser,
  onDeactivateUser,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="h-8 w-8 p-0 hover:bg-gray-200 transition-colors"
          variant="ghost"
        >
          <span className="sr-only">Open menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px] p-2 bg-white">
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
          onClick={() => onEdit(employeeUuid)}
        >
          Edit User
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
          onClick={() => onImpersonate(employeeUuid)}
        >
          Impersonate User
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
          onClick={onSyncUser}
        >
          Sync User
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 transition-colors"
          onClick={onViewSyncLogs}
        >
          View Sync Logs
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex items-center px-3 py-2 text-sm cursor-pointer text-red-600 hover:bg-red-50 transition-colors"
          disabled={!isActive}
          onClick={onDeactivateUser}
        >
          Deactivate User
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AdminUserActionMenu;
